import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import useQuestionActions from "../../../api/hooks/admin/question";
import { isQuestionModifyModalOpenState } from "../../../recoil/admin/examRoom";
import {
  firstQuestionState,
  secondQuestionState,
  selectedComboSnState,
  thirdQuestionState,
} from "../../../recoil/admin/question";
import { languageOption } from "../../../static/options";
import Select from "../../atoms/input/Select";
import useExamRoomActions from "../../../api/hooks/admin/examRoom";
import { useMutation } from "@tanstack/react-query";
import { languageOptionReturn } from "../../../static/options";

const AdminModalQuestion = ({ questionNumber }) => {
  const modalState = useRecoilValue(isQuestionModifyModalOpenState);
  const [firstQuestion, setFirstQuestion] = useRecoilState(firstQuestionState);
  const [secondQuestion, setSecondQuestion] =
    useRecoilState(secondQuestionState);
  const [thirdQuestion, setThirdQuestion] = useRecoilState(thirdQuestionState);

  const comboSn = useRecoilValue(selectedComboSnState);

  const { fetchCombo } = useQuestionActions();

  useQuery({
    queryKey: ["fetchCombo", modalState],
    queryFn: () => fetchCombo({ sn: comboSn }),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: modalState,
    onSuccess: (context) => {
      if (comboSn && context?.data[0]) {
        var contextData = { ...context?.data[0] };
        contextData.url = contextData?.voice_url ? contextData?.voice_url : "";
        delete contextData?.voice_url;
        setFirstQuestion(contextData);
        // console.log("1", context?.data[0]);
        // console.log("2", contextData);
      }
      if (comboSn && context?.data[1]) {
        var contextData = { ...context?.data[1] };
        contextData.url = contextData?.voice_url ? contextData?.voice_url : "";
        delete contextData?.voice_url;
        setSecondQuestion(contextData);
        // console.log("3", context?.data[1]);
        // console.log("4", contextData);
      }
      if (comboSn && context?.data[2]) {
        var contextData = { ...context?.data[2] };
        contextData.url = contextData?.voice_url ? contextData?.voice_url : "";
        delete contextData?.voice_url;
        setThirdQuestion(contextData);
        // console.log("5", context?.data[2]);
        // console.log("6", contextData);
      }
    },
  });

  // 음성파일생성
  const [langWord, setLangWord] = useState("ko");
  const [sttUrl, setSttUrl] = useState(
    "https://www.w3schools.com/html/horse.ogg"
  );
  const { getTts } = useExamRoomActions();

  const createSttMutate = useMutation(getTts, {
    onSuccess: (result) => {

      if (result.status === 200) {
        setSttUrl(result.data.url);

        switch (questionNumber) {
          case 1:
            setFirstQuestion({
              ...firstQuestion,
              url: result.data.url,
            });
            break;
          case 2:
            setSecondQuestion({
              ...secondQuestion,
              url: result.data.url,
            });
            break;
          case 3:
            setThirdQuestion({
              ...thirdQuestion,
              url: result.data.url,
            });
            break;
          default:
            break;
        }
      } else {
        if (result.response.status === 400) {
          alert(result.response.data.text);
        } else {
          alert("예상치 못한 에러가 발생했습니다. 잠시후 시도해주세요.(1)");
        }
      }
    },
    onError: () => {
      alert("예상치 못한 에러가 발생했습니다. 잠시후 시도해주세요.(2)");
    },
  });

  const createStt = () => {
    var sttText = "";
    switch (questionNumber) {
      case 1:
        sttText = firstQuestion.text;
        break;
      case 2:
        sttText = secondQuestion.text;
        break;
      case 3:
        sttText = thirdQuestion.text;
        break;
      default:
        break;
    }
    var params = {
      lang: langWord,
      speaker: languageOptionReturn(langWord),
      text: sttText,
    };
    createSttMutate.mutate(params);
  };

  // 음성재생
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = React.createRef();

  const toggleAudio = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <tr>
      <td>{questionNumber}</td>
      <td className="text-align-left width-742">
        <textarea
          className="q-insert-input motto-input mb-10"
          placeholder="문제를 입력하세요."
          value={
            questionNumber == 1
              ? firstQuestion?.text
              : questionNumber == 2
              ? secondQuestion?.text
              : questionNumber == 3
              ? thirdQuestion?.text
              : ""
          }
          required
          onChange={(e) => {
            switch (questionNumber) {
              case 1:
                setFirstQuestion({ ...firstQuestion, text: e.target.value });
                break;
              case 2:
                setSecondQuestion({ ...secondQuestion, text: e.target.value });
                break;
              case 3:
                setThirdQuestion({ ...thirdQuestion, text: e.target.value });
                break;
              default:
                break;
            }
          }}
        />
        <br />
        <Select
          placeholder="선택"
          options={languageOption}
          style={{ width: "100px" }}
          className="mb-10"
          onChange={(e) => {
            setLangWord(e.target.value);
            switch (questionNumber) {
              case 1:
                setFirstQuestion({
                  ...firstQuestion,
                  langauge: e.target.value,
                });
                break;
              case 2:
                setSecondQuestion({
                  ...secondQuestion,
                  langauge: e.target.value,
                });
                break;
              case 3:
                setThirdQuestion({
                  ...thirdQuestion,
                  langauge: e.target.value,
                });
                break;
              default:
                break;
            }
          }}
        />
        <button
          type="button"
          className="q-insert-btn listen mb-10"
          onClick={(e) => {
            createStt();
          }}
        >
          음성파일생성
        </button>
        <br />
        <button
          type="button"
          className="q-insert-btn listen"
          onClick={toggleAudio}
        >
          음성듣기
        </button>
        <audio
          ref={audioRef}
          controls="controls"
          style={{ width: "80%", verticalAlign: "bottom" }}
          src={
            questionNumber === 1
              ? firstQuestion.url
              : questionNumber === 2
              ? secondQuestion.url
              : questionNumber === 3
              ? thirdQuestion.url
              : ""
          }
        ></audio>
      </td>
      <td>
        <input
          size={5}
          type="number"
          required
          value={
            questionNumber == 1
              ? firstQuestion?.ready_time_second
              : questionNumber == 2
              ? secondQuestion?.ready_time_second
              : questionNumber == 3
              ? thirdQuestion?.ready_time_second
              : ""
          }
          onChange={(e) => {
            switch (questionNumber) {
              case 1:
                setFirstQuestion({
                  ...firstQuestion,
                  ready_time_second: e.target.value,
                });
                break;
              case 2:
                setSecondQuestion({
                  ...secondQuestion,
                  ready_time_second: e.target.value,
                });
                break;
              case 3:
                setThirdQuestion({
                  ...thirdQuestion,
                  ready_time_second: e.target.value,
                });
                break;
              default:
                break;
            }
          }}
          style={{
            border: "1px solid rgb(193, 194, 195)",
            padding: "6px 12px",
          }}
        />
      </td>
      <td>
        <input
          size={5}
          type="number"
          required
          value={
            questionNumber == 1
              ? firstQuestion?.minres_time_second
              : questionNumber == 2
              ? secondQuestion?.minres_time_second
              : questionNumber == 3
              ? thirdQuestion?.minres_time_second
              : ""
          }
          onChange={(e) => {
            switch (questionNumber) {
              case 1:
                setFirstQuestion({
                  ...firstQuestion,
                  minres_time_second: e.target.value,
                });
                break;
              case 2:
                setSecondQuestion({
                  ...secondQuestion,
                  minres_time_second: e.target.value,
                });
                break;
              case 3:
                setThirdQuestion({
                  ...thirdQuestion,
                  minres_time_second: e.target.value,
                });
                break;
              default:
                break;
            }
          }}
          style={{
            border: "1px solid rgb(193, 194, 195)",
            padding: "6px 12px",
          }}
        />
      </td>
      <td>
        <input
          size={5}
          type="number"
          required
          value={
            questionNumber == 1
              ? firstQuestion?.maxres_time_second
              : questionNumber == 2
              ? secondQuestion?.maxres_time_second
              : questionNumber == 3
              ? thirdQuestion?.maxres_time_second
              : ""
          }
          onChange={(e) => {
            switch (questionNumber) {
              case 1:
                setFirstQuestion({
                  ...firstQuestion,
                  maxres_time_second: e.target.value,
                });
                break;
              case 2:
                setSecondQuestion({
                  ...secondQuestion,
                  maxres_time_second: e.target.value,
                });
                break;
              case 3:
                setThirdQuestion({
                  ...thirdQuestion,
                  maxres_time_second: e.target.value,
                });
                break;
              default:
                break;
            }
          }}
          style={{
            border: "1px solid rgb(19, 22, 24)",
            padding: "6px 12px",
          }}
        />
      </td>
    </tr>
  );
};

export default AdminModalQuestion;
